import store from '../../index.js'

const state = {
  labeling: {},
}

const getters = {
  getLabeling: state => state.labeling,
}

const mutations = {
  loadLabelingFromLocalStorage (state, payload) {
    const labeling = JSON.parse(payload)

    for (const key in labeling) {
      for (const labelKey in labeling[key]) {
      // this has to be done because in a LabelClass there's 2 types of labeling expressions
      // if you set a multi attribute labelExpression using labelExpression syntax
      // that will automatically create a clause on the labelExpressionInfo property
      // for example [objectid] CONCAT [tip] will be $feature.objectid + $feature.tip in labelExpressionInfo snytax
      // the problem is, if we generate a labelClass using .fromJSON(), and the json has a complex labelExpressionInfo clause
      // label won't appear, label MUST only be set from labelExpression
        labeling[key][labelKey].labelClass.labelExpressionInfo = null
      }
    }
    state.labeling = labeling
  },
  saveLabeling (state, payload) {
    const compositeKey = payload.storeKey + (payload.layerKey || payload.layerKey === 0 ? `##${payload.layerKey}` : '')
    const localStoragePropName = `labeling-${store.getters.getViewerName}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : '')

    if (Object.keys(payload.labeling).length < 1) {
      const tempLabeling = { ...state.labeling }
      delete tempLabeling[compositeKey]
      state.labeling = tempLabeling
      localStorage.setItem(localStoragePropName, JSON.stringify(state.labeling))
      return
    }
    const labelingTemp = {}

    for (const key in payload.labeling) {
      labelingTemp[key] = {
        isLabelActive: payload.labeling[key].isLabelActive,
        labelClass: payload.labeling[key].labelClass.toJSON(),
      }
    }
    state.labeling = {
      ...state.labeling,
      [compositeKey]: labelingTemp,
    }
    localStorage.setItem(localStoragePropName, JSON.stringify(state.labeling))
  },
}

const actions = {
  saveLabeling ({ commit }, payload) {
    commit('saveLabeling', payload)
  },
  loadLabelingFromLocalStorage ({ commit }, payload) {
    commit('loadLabelingFromLocalStorage', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
